import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TimeDurationState {
  time_data: string | number | Array;
  tabs: any; // Adjusted to allow any type for tab
  selectedAppStatus : string
}

const initialState: TimeDurationState = {
  time_data: { from_date: "", to_date: "" },
  tabs: {},
  selectedAppStatus : ""
};

const timeDuraionSlice = createSlice({
  name: "time",
  initialState,
  reducers: {
    setSelectedTimeData: (state, action: PayloadAction<string | number>) => {
      state.time_data = { ...state.time_Data, ...action.payload };
    },
    // setActiveTab: (state, action) => {
    //   state.tab = action.payload;
    // },

    setActiveTab: (state, action) => {
      const { key, tab } = action.payload;
      state.tabs[key] = tab;
    },

    setSelectedAppStatus: (state, action) => {
     state.selectedAppStatus = action.payload;
    },
  },
});

export const { setSelectedTimeData, setActiveTab, setSelectedAppStatus } =
  timeDuraionSlice.actions;
export default timeDuraionSlice.reducer;
